/**
 * Enum for map panel tab types
 * @readonly
 * @enum {string}
 */
export const Tab = {
    /** Report/District tab */
    REPORT: 'report',
    /** Filter tab */
    FILTER: 'filter',
    /** Demographics tab */
    DEMOGRAPHICS: 'demographics',
    /** Classifications tab */
    CLASSIFICATIONS: 'classifications'
};

export default Tab;

